import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init("yMWtp-advQULPlbKu");

const EMAILJS_SERVICE_ID = 'PersonalPortfolio';
const EMAILJS_TEMPLATE_ID = 'MainEmailTemplate';

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const sendEmail = async (
  email: string, 
  message: string, 
  onError: (message: string, title?: string) => void
): Promise<void> => {
  // Validate inputs before sending
  if (!email || !validateEmail(email)) {
    onError('Please enter a valid email address', 'Invalid Email');
    throw new Error('Invalid email address');
  }

  if (!message.trim()) {
    onError('Please enter a message', 'Empty Message');
    throw new Error('Message cannot be empty');
  }

  try {
    console.log('Sending email with:', {
      email,
      message: message.trim(),
      serviceId: EMAILJS_SERVICE_ID,
      templateId: EMAILJS_TEMPLATE_ID
    });

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        from_email: email,
        message: message.trim(),
        to_name: 'Pranav',
        from_name: email.split('@')[0], // Use the part before @ as the name
      }
    );

    console.log('Email sent successfully:', response);

    if (response.status !== 200) {
      onError('Failed to send email. Please try again later.', 'Error');
      throw new Error('Failed to send email');
    }
  } catch (error) {
    console.error('Error sending email:', error);
    if (error instanceof Error) {
      onError(error.message, 'Error');
      throw new Error(`Failed to send email: ${error.message}`);
    } else {
      onError('Failed to send email. Please try again later.', 'Error');
      throw new Error('Failed to send email. Please try again later.');
    }
  }
}; 